"use client";

import type { NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useRouter as useNextRouter } from "next/navigation";
import { cleanHrefWithSiteBasePath } from "./clean-href-with-site-base-path";
import { useRouterContext } from "./context";
import { isExternal } from "./is-external";
import { isSupportedRouterNavigation } from "./is-supported-router-navigation";

export const useRouter = () => {
  const nextRouter = useNextRouter();
  const { appRouterPathPrefixes, siteBasePath } = useRouterContext();

  return {
    ...nextRouter,
    push: (to: string, options?: NavigateOptions) => {
      if (isExternal(to, siteBasePath)) {
        window.location.href = to;
        return;
      }

      const destination = cleanHrefWithSiteBasePath({
        href: to,
        siteBasePath,
      });

      const isSupportedRouterNavigationForCurrentPage =
        isSupportedRouterNavigation({
          appRouterPathPrefixes,
          siteBasePath,
          to: destination,
        });

      if (isSupportedRouterNavigationForCurrentPage) {
        nextRouter.push(destination, options);
      } else {
        window.location.href = `${window.location.origin}${destination}`;
      }
    },
    replace: (to: string, options?: NavigateOptions) => {
      if (isExternal(to, siteBasePath)) {
        console.log("Navigating to external URL:", to);

        window.location.replace(to);
        return;
      }

      const destination = cleanHrefWithSiteBasePath({
        href: to,
        siteBasePath,
      });

      const isSupportedRouterNavigationForCurrentPage =
        isSupportedRouterNavigation({
          appRouterPathPrefixes,
          siteBasePath,
          to: destination,
        });

      if (isSupportedRouterNavigationForCurrentPage) {
        nextRouter.replace(destination, options);
      } else {
        window.location.replace(`${window.location.origin}${destination}`);
      }
    },
  };
};
